export default __webpack_public_path__ + "static/media/django.b5829c14.svg";